<template>
  <step-container :number="stepNumber" title="¿Dónde te gustaría grabar?">

    <div class="flex flex-col gap-6 items-start flex-auto">
      <titled-divider :title="'Presencial'" />
      <card-option
        v-model="option"
        content="study"
        index="1"
        :stepNumber="stepNumber"
        name="modality"
        :disabled="!protagonistInterviewee"
      >
        <card-option-content
          title="Estudio Memoorias"
          description="Estudio profesional de grabación ubicado en Centro Parque (Parque Araucano)"
          price="+20.000 CLP"
          :image-src="videoIllustration"
        >
          <template #title>
            <video-modal
              dialogTitle="Estudio de grabación - Memooria Presencial"
              videoSource="https://s3.us-east-2.amazonaws.com/app.memoorias.com/public/Estudio+Presencial.mp4"
              triggerLabel="Cuándo optar por el estudio de Memoorias"
            />
          </template>
          <template #details>
            <a
              class="text-pink-700 text-[10px] font-normal font-['Montserrat'] underline"
              target="_blank"
              tabindex="-1"
              href="https://www.google.cl/maps/place/Escapology+Chile/@-33.4034758,-70.5778033,17z/data=!3m1!4b1!4m6!3m5!1s0x9662cf6a30ffbc93:0x3d1b0952496e945b!8m2!3d-33.4034803!4d-70.5752284!16s%2Fg%2F11g2wqvxr_?entry=ttu"
            >
              Ver ubicación
            </a>

            <span v-if="!protagonistInterviewee" class="text-[10px] flex"
              >*Solo disponible para entrevistas con protagonista</span
            >
          </template>
        </card-option-content>
      </card-option>
    </div>

    <div class="flex flex-col gap-6 items-start flex-auto">
      <titled-divider :title="'Online'" />
      <card-option
        v-model="option"
        content="online"
        index="0"
        :stepNumber="stepNumber"
        name="modality"
      >
        <card-option-content
          title="Experiencia online"
          description="Plataforma online especial para grabar podcast en cualquier parte del mundo"
          price="Incluido"
          :image-src="pcIllustration"
        >
          <template #title>
            <video-modal
              dialogTitle="Experiencia online - Memooria Online"
              videoSource="https://s3.us-east-2.amazonaws.com/app.memoorias.com/public/Online.mp4"
              triggerLabel="Cuándo elegir una Memooria online"
            />
          </template>
        </card-option-content>
      </card-option>
    </div>
  </step-container>
</template>

<script setup>
import pcIllustration from "@assets/images/pc-screen.webp";
import videoIllustration from "@assets/images/video.webp";
import TitledDivider from "../TitledDivider.vue";
</script>

<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

import VideoModal from "../VideoModal.vue";
import StepContainer from "../layouts/StepContainer.vue";
import CardOption from "../options/CardOption.vue";
import CardOptionContent from "../options/CardOptionContent.vue";

export default {
  mixins: [stepMixin, optionMixin],
  components: {
    StepContainer,
    CardOption,
    CardOptionContent,
    TitledDivider,
  },
  props: {
    protagonistInterviewee: {
      type: Boolean,
    },
  },
  watch: {
    protagonistInterviewee: {
      handler: function (protagonistInterviewee) {
        if (!protagonistInterviewee && this.option === "study") {
          this.option = "online";
        }
      },
      immediate: true,
    },
  },
};
</script>
